<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="row" [formGroup]="formGroup">
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <label class="control-label" *ngIf="showLabel" i18n="@@generalConditions">Terms and Uses</label>

    <mat-checkbox [formControlName]="controlName" color="primary">
      <span i18n="@@termsAndConditionsConfirm">I confirm that I have read and accepted</span>&nbsp;
      <a href="./cgv" target="_blank" i18n="@@termsSales">Terms of sales</a>&nbsp;
      <span i18n="@@and">and</span>&nbsp;
      <a href="./cgu" target="_blank" i18n="@@termsUse">Terms of use</a>
    </mat-checkbox>

    <div *ngIf="submitted && control?.invalid" class="invalid-feedback d-block">
      <div *ngIf="control?.hasError('required')" i18n="@@generalConditionsRequired">
        Terms and Uses conditions are required.
      </div>
    </div>
  </div>
</div>
